export enum AppRoutePaths {
  Default = '',
  Login = 'login',
  Eula = 'eula',
  Waiting = 'waiting',
  Training = 'training',
  TrainingDetails = 'training/details/',
  Details = 'details',
  Library = 'library',
  LibraryFTO = 'library/fto',
  Document = 'training/document',
  Learning = 'learning',
  LearningFTO = 'learning/fto',
  Error = 'error',
  Schedule = 'schedule',
  ScheduleNotification = 'scheduleNotification',
  PreCheckin = 'pre-checkin',
  AzureAppInsight = 'azure-app-insight',
  RateExperience = 'rate-experience',
  Settings = 'settings',
  User = 'user',
  AccessPass = 'access-pass'
}
